import { Upload } from "lucide-react";
import React from "react";

interface UploadButtonProps {
  title: string;
  onClick: () => void;
  className?: string;
}

const UploadButton: React.FC<UploadButtonProps> = ({
  title,
  onClick,
  className = "",
}) => {
  return (
    <div
      className={`w-24 h-32 rounded-xl border-2 bg-primary/10 border-dotted border-border flex flex-col items-center justify-center cursor-pointer hover:bg-primary/20 transition p-2.5 ${className}`}
      onClick={onClick}
    >
      <div className="flex flex-col items-center">
        <div className="bg-primary p-2 rounded-full mb-2">
          <Upload className="h-6 w-6 text-primary-foreground" />
        </div>
        <span className="text-primary font-medium text-center text-sm">
          {title}
        </span>
      </div>
    </div>
  );
};

export default UploadButton;
